import { render } from "./signUpToBuy.vue?vue&type=template&id=30f1b845&scoped=true"
import script from "./signUpToBuy.vue?vue&type=script&lang=js"
export * from "./signUpToBuy.vue?vue&type=script&lang=js"

import "./signUpToBuy.vue?vue&type=style&index=0&id=30f1b845&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30f1b845"

export default script